import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { getPosition, savePosition } from './../../reducers/positions';
import Wizard from './../../components/wizard';
import { PositionTheWorkStep, PositionThePayStep, PositionTheWorkerStep, PositionTheReviewStep, PositionTheWorkLocationStep } from './steps';
import { setProgress } from '../../reducers/wizard';
import { history } from '../../configuration/store';
import { getClientsProjects } from '../../reducers/projects';
import { getTimezones } from '../../text/selectOptions';

class PositionPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { positionId: undefined };

        this.getSteps = this.getSteps.bind(this);
        this.setPositionId = this.setPositionId.bind(this);
    }
    componentDidMount() {
        const { match, getPosition, setProgress, getClientsProjects, projects, role } = this.props;
        if (match && match.params && match.params.id !== 'new') {
            getPosition(match.params.id, true, position => setProgress({ entity: 'position', id: match.params.id }, position.progress));
        }
        if (!projects) {
            getClientsProjects(role.id, 'active');
        }
    }

    setPositionId(id, formValues, onComplete) {
        this.setState({ positionId: id, ...formValues }, onComplete);
    }

    getSteps(controls, progress) {
        const { role, profile, savePosition, position } = this.props;
        const { positionId } = this.state;
        const { branch } = progress;
        const timezones = getTimezones();

        // if Pacific time is available, use it as default
        // TODO - infer this from the job location
        const pacificTimeIndex = timezones.findIndex(tz => tz.value === 'America/Los_Angeles');
        const timeZoneIndex = pacificTimeIndex || 0;
        let initialValues = {
            client_id: role.id,
            hm_id: profile.id,
            backup_approval_id: profile.id,
            work_location_type: 'onsite',
            work_timezone: timezones[timeZoneIndex].value,
            classify_client_pref: 'w2-or-ic',
            contractor_type: 'individual',
            pay_type: 'h',
            po_when: 'now'
        };

        let controlsWithCancel = { ...controls, cancel: () => history.push('/positions') };

        return [
            <PositionTheWorkStep
                onSubmit={v => savePosition(v, response => this.setPositionId(response.id, v, () => controls.next(1, response.id, branch)))}
                title={<FormattedMessage id={'positionTheWork'} defaultMessage={'What is the work?'} />}
                initialValues={initialValues}
                positionId={positionId}
                {...this.props}
                {...controlsWithCancel}
            />,
            <PositionTheWorkLocationStep
                onSubmit={v => savePosition(v, controls.next(2, positionId, branch))}
                title={<FormattedMessage id={'positionTheWorkLocation'} defaultMessage={'Where is the work?'} />}
                initialValues={initialValues}
                positionId={positionId}
                {...this.props}
                {...controlsWithCancel}
            />,
            <PositionThePayStep
                title={<FormattedMessage id={'positionThePay'} defaultMessage={'What is the pay?'} />}
                initialValues={{ ...initialValues, ...(position ? position : {}) }}
                positionId={positionId}
                {...this.props}
                {...controlsWithCancel}
            />,
            <PositionTheWorkerStep
                branch={branch}
                title={<FormattedMessage id={'positionTheWorker'} defaultMessage={'Who is doing the work?'} />}
                initialValues={initialValues}
                {...this.props}
                {...controlsWithCancel}
            />,
            <PositionTheReviewStep
                title={<FormattedMessage id={'positionReview'} defaultMessage={'Review and invite'} />}
                initialValues={initialValues}
                positionId={positionId}
                {...this.props}
                {...controlsWithCancel}
            />
        ];
    }

    render() {
        const { match, position } = this.props;

        let existingPosition = match && match.params && match.params.id !== 'new';
        let id = existingPosition ? match.params.id : undefined;
        if (existingPosition && !position) {
            return null;
        }

        return <Wizard configuration={{ entity: 'position', id }} getSteps={this.getSteps} />;
    }
}

PositionPage.meta = {
    hide: true,
    locations: ['/position/']
};

const mapStateToProps = (state, props) => ({
    position: state.positions[props.match.params.id],
    profile: state.identity.profile,
    projcets: state.projects.list
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getPosition,
            savePosition,
            setProgress,
            getClientsProjects
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PositionPage);



// WEBPACK FOOTER //
// ./src/pages/position/index.jsx